import * as React from 'react';
import { ButtonContainer, Container, Content, FileName, FileSize, IconContainer, Image, MetaInfo } from './Attachment.styled';
import { IconButton } from '../icon-button';
import { Pictogram } from '../pictogram';
import { Loading } from './Loading';
const fileTypes = {
    pdf: React.createElement(Pictogram, { name: "pdf", size: 48 }),
    document: React.createElement(Pictogram, { name: "document", size: 48 }),
    img: React.createElement(Pictogram, { name: "picture", size: 48 }),
    video: React.createElement(Pictogram, { name: "video", size: 48 }),
    doc: React.createElement(Pictogram, { name: "wordDoc", size: 48 }),
    docx: React.createElement(Pictogram, { name: "wordDoc", size: 48 })
};
export const Attachment = ({ imageUrl, loading = false, onClose, name, size, stack, type }) => {
    return loading ? React.createElement(Loading, { stack: stack }) : (React.createElement(Container, { stack: stack },
        React.createElement(Content, { stack: stack },
            React.createElement(IconContainer, { stack: stack }, imageUrl && type === 'img'
                ? React.createElement(Image, { stack: stack, src: imageUrl, alt: name })
                : fileTypes[type]),
            React.createElement(MetaInfo, { stack: stack },
                React.createElement(FileName, null, name),
                React.createElement(FileSize, null, size))),
        React.createElement(ButtonContainer, { stack: stack },
            React.createElement(IconButton, { "aria-label": "delete-attachment-button", fill: "clear", icon: "Close", onClick: onClose, size: "small", variant: "secondary" }))));
};
//# sourceMappingURL=Attachment.js.map